import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
    padding: $theme.sizing.scale700,
    gap: $theme.sizing.scale900
}))

export const Link = styled('a', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    textDecorationLine: 'underline',
    cursor: 'pointer'
}))
